import { Offer } from 'src/types/offer'

export const getButtonAccessibleText = (isBabylistOffer: boolean): string =>
  isBabylistOffer ? 'Add to Babylist cart' : 'Buy from store'

export const getHandleClick = (offer: Offer) => () => {
  if (offer.isBabylist) {
    console.log('Add to Babylist cart clicked')
  } else {
    window.open(offer.url, '_blank')
  }
}
